import { gql } from "@apollo/client";

export const schema = {
    // contact us 
    contactUs: (query: string) => gql`
        mutation contactUs($contactMessage: ContactMessageInput!) {
            contactUs(contactMessage: $contactMessage) {
                ${query}
            }
        }
    `,
    getUserStatusStats: (query: string) => gql`
        query getUserStatusStats {
            getUserStatusStats {
                ${query}
            }
        }
    `,
    getAdminUserStatusStats: (query: string) => gql`
        query getAdminUserStatusStats {
            getAdminUserStatusStats {
                ${query}
            }
        }
    `,
    getNotification: (query: string) => gql`
        query getNotification($notification: NotificationInput!) {
            getNotification(notification: $notification){
                ${query}
            }
        }
    `,
    getNotificationCount: (query: string) => gql`
        query getNotificationCount($userId: String!) {
            getNotificationCount(userId: $userId){
                ${query}
            }
        }
    `,
    getNotifications: (query: string) => gql`
        query getNotifications($notificationIds: [String], $notification: NotificationInput, $limit: Int!, $skip: Int!) {
            getNotifications(notificationIds: $notificationIds, notification: $notification, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,
    deleteUser: (query: string) => gql`
        mutation deleteUser($userId: String!) {
            deleteUser(userId: $userId) {
                ${query}
            }
        }
    `,
    updateUser: (query: string) => gql`
        mutation updateUser($userId: String!, $user: UserInput!) {
            updateUser(userId: $userId, user: $user) {
                ${query}
            }
        }
    `,
    getUser: (query: string) => gql`
        query getUser($user: UserInput!){
            getUser(user: $user){
                ${query}
            }
        }
    `,
    getUsers: (query: string) => gql`
        query getUsers($userIds: [String], $user: UserInput, $search: String, $limit: Int!, $skip: Int!){
            getUsers(userIds: $userIds, user: $user, search: $search, limit: $limit, skip: $skip){
                ${query}
            }
        }
    `,
    me: (query: string) => gql`
        query {
            me {
                ${query}
            }
        }
    `

}